/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { ZillowSVGImage } from '../../common/ZillowSVGImage/ZillowSVGImage';
import { InternalLogoProps } from './InternalLogoProps';

export type ZillowIconProps = {
    staticDomain: StaticDomainConfiguration;
    isMobileNavOpen: boolean;
    version: HEADER_VERSIONS;
};

const StyledZillowIcon = styled(ZillowSVGImage)<InternalLogoProps>`
    ${({ version, isMobileNavOpen }) => css`
        height: 25px;
        display: none;
        ${!isMobileNavOpen &&
        css`
            @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                display: block;
            }
        `}
    `}
`;
export const ZillowIcon: FunctionComponent<ZillowIconProps> = ({ staticDomain, version, isMobileNavOpen }) => (
    <StyledZillowIcon
        version={version}
        isMobileNavOpen={isMobileNavOpen}
        svgFileName="z-logo-icon"
        svgName="Zillow logo"
        staticDomain={staticDomain}
    />
);
